import type { FaireProductEntity } from "../../entity_types/product";

export const p_9puv20a: FaireProductEntity = {
  token: "p_9puv20a",
  type: "product",
  name: "Gourmet Snack Mix",
  brandName: "Manhattan Snack Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/88286f78cad0921e5e4940ca2f4cfc752fa0346cb502a79c1f621d15dec945eb.webp",
  priceDollars: 11,
  description: "Premium snack mix with nuts, seeds, and dried fruit",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "artisanal"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/88286f78cad0921e5e4940ca2f4cfc752fa0346cb502a79c1f621d15dec945eb.webp",
  weight: 0.6,
  dimensions: {
    width: 5,
    height: 7,
    depth: 2,
  },
  inStock: true,
};
